import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Engagements from "@/pages/Engagements";
import EngagementDetail from "@/pages/EngagementDetail";
import Tasks from "@/pages/Tasks";
import Pipeline from "@/pages/Pipeline";
import Team from "@/pages/Team";
import Notes from "@/pages/Notes";
import Invoices from "@/pages/Invoices";
import Settings from "@/pages/Settings";
import PublicInvoiceView from "@/pages/PublicInvoiceView";
import FirmBrief from "@/pages/FirmBrief";
import FirmLibrary from "@/pages/FirmLibrary";
import Imports from "@/pages/Imports";
import Method from "@/pages/Method";
import ReflectionBalance from "@/pages/ReflectionBalance";
import EmbraceExplorations from "@/pages/EmbraceExplorations";
import VoiceLibrary from "@/pages/VoiceLibrary";
import ContactDirectory from "@/pages/ContactDirectory";
import "@/App.css";

function Private({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex h-screen items-center justify-center text-muted-foreground">Loading YadidOS…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Public({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/invoice/:id/view" element={<PublicInvoiceView />} />
            <Route path="/embrace-explorations" element={<EmbraceExplorations />} />
            <Route path="/login" element={<Public><Login /></Public>} />
            <Route path="/register" element={<Public><Register /></Public>} />
            <Route element={<Private><Layout /></Private>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/:id" element={<ClientDetail />} />
              <Route path="/contacts" element={<ContactDirectory />} />
              <Route path="/engagements" element={<Engagements />} />
              <Route path="/engagements/:id" element={<EngagementDetail />} />
              <Route path="/tasks" element={<Tasks />} />
              <Route path="/pipeline" element={<Pipeline />} />
              <Route path="/team" element={<Team />} />
              <Route path="/notes" element={<Notes />} />
              <Route path="/invoices" element={<Invoices />} />
              <Route path="/brief" element={<FirmBrief />} />
              <Route path="/library" element={<FirmLibrary />} />
              <Route path="/method" element={<Method />} />
              <Route path="/method/reflection-balance" element={<ReflectionBalance />} />
              <Route path="/voice-library" element={<VoiceLibrary />} />
              <Route path="/imports" element={<Imports />} />
              <Route path="/settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" />
      </AuthProvider>
    </div>
  );
}
